export default class FavoritesHandler {
    constructor() {
        this.addFavoritesToMenu();
        window.addEventListener("favoritesUpdated", () => {
            this.addFavoritesToMenu();
        }); 
    }

    addFavoritesToMenu() {
        var favorites = JSON.parse(localStorage.getItem("favoriteList"));
        document.querySelectorAll("[data-menu-favorite]").forEach((el) => {
            if (favorites != null && favorites.length > 0) el.classList.add("show");
            else el.classList.remove("show");
        });
    }
}
